import { API_BASE_URL } from '@synergy/config';
import { FormattedMessage } from 'react-intl';
import {
    PoolButton,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolModalTitle,
    PoolSelect,
} from '@synergy/components-next';
import { SelectOption } from '@synergy/components';
import { useState } from 'react';
import urlJoin from 'url-join';

import {
    DemandExportListType,
    getDemandExportListTypeTranslationId,
} from '../../detail/models/demand-export-list-type-enum';

interface DemandExportListModalProps {
    demandId: number;
    open: boolean;
    onClose: () => void;
}

export const DemandExportListModal = ({ open, onClose, demandId }: DemandExportListModalProps) => {
    const [selectedExportListType, setSelectedExportListType] = useState<DemandExportListType>(
        DemandExportListType.Summary
    );

    const options: SelectOption[] = Object.values(DemandExportListType).map(exportListType => {
        return {
            value: exportListType,
            displayValue: (
                <FormattedMessage
                    key={exportListType}
                    id={getDemandExportListTypeTranslationId(exportListType as DemandExportListType)}
                />
            ),
        };
    });

    const handleClose = () => {
        setSelectedExportListType(DemandExportListType.Summary);
        onClose();
    };

    const handleExportList = (): void => {
        window.open(urlJoin(`${API_BASE_URL}/demands/${demandId}/pdf-overview?listType=${selectedExportListType}`));

        handleClose();
    };

    return (
        <PoolModal open={open} onClose={handleClose}>
            <PoolModalTitle>
                <FormattedMessage id="app.common.exportList" />
            </PoolModalTitle>
            <PoolModalContent>
                <PoolSelect
                    value={selectedExportListType}
                    fullWidth={true}
                    required={true}
                    options={options}
                    label={<FormattedMessage id="app.common.listType" />}
                    onChange={e => setSelectedExportListType(e.target.value as DemandExportListType)}
                />
            </PoolModalContent>
            <PoolModalActions>
                <PoolButton variant="outlined" onClick={handleClose}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>
                <PoolButton onClick={handleExportList}>
                    <FormattedMessage id="app.common.exportList" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
